import { FunctionComponent, memo } from "react";
import { IProps } from "./add-tag-group-menu.types";
import { ModalContent, ModalHeader } from "@edgetier/modal";
import CreateTagGroup from "components-for/tags/create-tag-group";
import "./add-tag-group-menu.scss";

/**
 * A menu for creating a new tag group.
 */
const AddTagGroupMenu: FunctionComponent<IProps> = () => (
    <>
        <ModalHeader>
            <h2>Create Tag Group</h2>
        </ModalHeader>
        <ModalContent>
            <CreateTagGroup />
        </ModalContent>
    </>
);

export default memo(AddTagGroupMenu);
